import graphql__cc30e54b46f82636a225 from "./__generated__/ContactContactView_contact.graphql.ts";import * as React from "react";
import {Suspense} from "react";
import {graphql} from "react-relay";
import Panel from "./presentational/Panel";
import ContactDataList from "./ContactDataList";
import ContactCustomersPanel from "./ContactCustomersPanel";
import ContactAttributesPanel from "./ContactAttributesPanel";
import ActivityPanel from "./ActivityPanel";
import {useFragment} from "react-relay/hooks";
import {hideModal, showModal} from "../store/actions";
import {connect, ConnectedProps} from "react-redux";
import {useOutletContext} from "react-router";
import {useIntl} from "react-intl";
import ActionButton from "./presentational/button/ActionButton";
import {faTrash} from "@fortawesome/pro-regular-svg-icons";
import DeleteContactDialog from "./dialog/DeleteContactDialog";

type Props = {}

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});

type ContactContactViewProps = Props & ConnectedProps<typeof connector>;

const ContactContactView: React.FC<ContactContactViewProps> = (props) => {
    const queryRef: any = useOutletContext();
    const intl = useIntl();
    const {dispatchShowModal, dispatchHideModal} = props;

    const contact = useFragment(
        graphql__cc30e54b46f82636a225,
        queryRef
    );
    if (contact == null) {
        return <p>{intl.formatMessage({id: 'contact.notFound'})}</p>;
    }

    const showDeleteContactDialog = () => {
        dispatchShowModal({
            body: (<DeleteContactDialog queryRef={contact} handleCloseDialog={dispatchHideModal}/>)
        })
    };

    return (
        <>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div className="space-y-6">
                    <Panel headline={contact.__typename === 'TeamContact' ? intl.formatMessage({id: 'contact.type.team'}) : intl.formatMessage({id: 'contact.type.individual'})}>
                        <ContactDataList queryRef={contact}/>
                    </Panel>
                    <ContactCustomersPanel queryRef={contact} />
                    <ContactAttributesPanel queryRef={contact} />
                </div>
                <div>
                    <Suspense fallback={<Panel headline={intl.formatMessage({id: 'activity.recentActivity', defaultMessage: 'Recent Activity'})}><div className="py-8 text-center text-gray-400">Loading...</div></Panel>}>
                        <ActivityPanel contactId={contact.contactIdentifier} contactGraphqlId={contact.id} />
                    </Suspense>
                </div>
            </div>
            <div className="flex space-x-4 justify-end mt-6">
                <ActionButton onClick={showDeleteContactDialog} icon={faTrash} label={intl.formatMessage({id: 'button.deleteContact'})}/>
            </div>
        </>
    );
}

export default connector(ContactContactView);
